__webpack_require__.p = "/brat-generator/";